__turbopack_context__.v({
  "chips": "mobile-product-search-module__DhY6CW__chips",
  "content": "mobile-product-search-module__DhY6CW__content",
  "dialog": "mobile-product-search-module__DhY6CW__dialog",
  "form": "mobile-product-search-module__DhY6CW__form",
  "header": "mobile-product-search-module__DhY6CW__header",
  "history": "mobile-product-search-module__DhY6CW__history",
  "honestEmpty": "mobile-product-search-module__DhY6CW__honestEmpty",
  "iconButton": "mobile-product-search-module__DhY6CW__iconButton",
  "mode": "mobile-product-search-module__DhY6CW__mode",
  "modeActive": "mobile-product-search-module__DhY6CW__modeActive",
  "modeGrid": "mobile-product-search-module__DhY6CW__modeGrid",
  "sectionHead": "mobile-product-search-module__DhY6CW__sectionHead",
  "submit": "mobile-product-search-module__DhY6CW__submit",
});
